'use client';

import { Chip, Link, SpriteIcon } from '@coolblue-development/freddy';
import selectEntranceTrigger from '@coolblue-development/ga4-events/triggers/RelatedCategoryEntrance/selectEntranceTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductNavigationNode } from '@features/product-page/typings';

type RelatedProductsItemProps = {
  relatedProduct: ProductNavigationNode;
  componentType: 'link' | 'chip';
  index: number;
  totalIndices: number;
};

export const RelatedProductsItem = ({
  relatedProduct,
  componentType,
  index,
  totalIndices
}: RelatedProductsItemProps) => {
  const { trackEvent } = useAnalytics();

  const onClickHandler = (url: string, title: string, index: number, totalIndices: number) => {
    const params = {
      index: index + 1,
      total_indices: totalIndices,
      url: url,
      redirect: title
    };

    trackEvent(selectEntranceTrigger(params));
  };

  const showAsLink = componentType === 'link';
  const ItemComponent = showAsLink ? Link : Chip;

  return (
    <ItemComponent
      onClick={() => onClickHandler(relatedProduct.url, relatedProduct.title, index, totalIndices)}
      href={relatedProduct.url}
      {...(showAsLink &&
        index === totalIndices - 1 && {
          startIcon: <SpriteIcon name='arrow-right' />
        })}
    >
      {relatedProduct.title}
    </ItemComponent>
  );
};
